module.exports = __webpack_public_path__ + "static/media/gd.7c62ce7d.svg";